<template>
    <CMultiSelect
        :visible="visible"
        @change="onChange"
        @filterChange="onFilterChange"
    />
</template>

<script setup>
import { CMultiSelect } from '@coreui/vue-pro'
import { ref } from 'vue'
import _ from 'lodash'

const props = defineProps({
    minFilterLength: {
        type: Number,
        default: 3
    },
    filterOnEnter: {
        type: Boolean,
        default: true
    }
})

const emit = defineEmits(['change', 'update', 'searchInputChanged'])

const onChange = (values) => {
    emit('update', values.map((element) => element.value))
}

// Handle searching
const visible = ref(false)
const currentSearchTerm = ref()
const debounce = ref()

// Function to de-bounce an event that a search filter has changed
const debounceFilterChangeEvent = (timeout = 300) => {
    visible.value = true

    if (debounce.value !== undefined) {
        debounce.value.cancel()
    }

    debounce.value = _.debounce(() => { emit('searchInputChanged', currentSearchTerm.value) }, timeout)
    debounce.value()
}

// Handling of on filter change from CoreUI
const onFilterChange = (value) => {
    currentSearchTerm.value = value

    if (value.length < props.minFilterLength) {
        return
    }

    debounceFilterChangeEvent()
}

// Handling of force search by pressing they "Enter"
const handleKeys = (event) => {
    if (event.key && event.key === 'Enter') {
        debounceFilterChangeEvent(0)
    }
}

window.addEventListener('keydown', handleKeys)
</script>

<style scoped>
</style>
